import { render, staticRenderFns } from "./demo-selector.vue?vue&type=template&id=755b48a8&scoped=true&"
import script from "./demo-selector.vue?vue&type=script&lang=js&"
export * from "./demo-selector.vue?vue&type=script&lang=js&"
import style0 from "./demo-selector.vue?vue&type=style&index=0&id=755b48a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755b48a8",
  null
  
)

export default component.exports